import React from 'react';
import Link from '../../link';

interface Props {
  title: string;
  subtitle?: string;
  breadcrumb: {
    [key: string]: string;
  };
  hero: any;
}

const BookstoreLayout: React.FC<Props> = ({
  title,
  subtitle,
  breadcrumb,
  hero,
  children,
}) => (
  <section>
    <div className="bookstore-header">
      <div className="title">
        <div className="breadcrumb">
          <Link href={breadcrumb.url}>
            <a>
              <i className="fas fa-long-arrow-alt-left" /> {breadcrumb.text}
            </a>
          </Link>
        </div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="hero">{hero}</div>
    </div>
    <div className="bookstore">{children}</div>
    {/* language=CSS */}
    <style jsx>{`
      .bookstore-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
      }

      @media screen and (max-width: 850px) {
        .bookstore-header {
          flex-wrap: wrap;
          padding: 0 2rem;
        }
      }

      .bookstore-header .title {
        flex: 1 0 50%;
      }

      @media screen and (max-width: 850px) {
        .bookstore-header .title {
          flex: 1 0 100%;
        }
      }

      .title h2 {
        margin: 0;
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 400;
      }

      .title p {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
      }

      .bookstore-header .hero {
        flex: 1 0 60%;
      }

      @media screen and (max-width: 850px) {
        .bookstore-header .hero {
          flex: 1 0 100%;
        }
      }

      .breadcrumb {
        margin-bottom: 1rem;
        font-size: 14px;
        font-family: 'Volvo Novum', sans-serif;
      }

      .breadcrumb a {
        color: #333;
        text-decoration: none;
        transition: all 0.2s linear;
      }

      .breadcrumb a:hover {
        color: #707070;
      }
    `}</style>
  </section>
);

export default BookstoreLayout;
